import { render, staticRenderFns } from "./order-management.vue?vue&type=template&id=05a5b929&scoped=true"
import script from "./order-management.vue?vue&type=script&lang=js"
export * from "./order-management.vue?vue&type=script&lang=js"
import style0 from "./order-management.vue?vue&type=style&index=0&id=05a5b929&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a5b929",
  null
  
)

export default component.exports